export default __webpack_public_path__ + "static/favorit-b83724222fe45ae80aad503d602f6b1c.otf";